// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_hl-0";